$(document).ready(function() {
  $(".cmp-image__link").removeAttr("href");

  jQuery('img').each(function () {
    var $el = jQuery(this),
        title = $el.attr('title'),
        alt = $el.attr('alt');
    if (title === undefined || title == '' || alt === undefined || alt == '')
        return;     
    $el.attr('title', alt);
  });

  $('.cmp-carousel__action--pause').on('click', function() {
    $('.cmp-carousel__action--play').show();
    $('.cmp-carousel__action--play').prop('disabled', false);
    $('.cmp-carousel__action--play').removeClass('cmp-carousel__action--disabled');
    $('.cmp-carousel__action--pause').hide();
    $('.cmp-carousel__action--pause').prop('disabled', true);
    $('.cmp-carousel__action--pause').addClass('cmp-carousel__action--disabled');
  });

  $('.cmp-carousel__action--play').on('click', function() {
    $('.cmp-carousel__action--pause').show();
    $('.cmp-carousel__action--pause').prop('disabled', false);
    $('.cmp-carousel__action--pause').removeClass('cmp-carousel__action--disabled');
    $('.cmp-carousel__action--play').hide();
    $('.cmp-carousel__action--play').prop('disabled', true);
    $('.cmp-carousel__action--play').addClass('cmp-carousel__action--disabled');
  });
});
